import { useEffect, useState } from "react"

export function useIsTablet() {
  const [isTablet, setIsTablet] = useState(false)
  const handleResize = () => {
    setIsTablet(window.innerWidth <= 1240 && window.innerWidth > 768)
  }

  useEffect(() => {
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return isTablet
}